import {useAuthStore} from '@toolify/client/src/stores/AuthStore/useAuthStore'
import {ThemeVariableType} from '@toolify/client/src/modules/theme/enum/ThemeVariableType'
import {IThemeVariables} from '@toolify/client/src/modules/theme/types/IThemeVariables'
import {ThemeTypeToThemeVariablesMap} from '@toolify/client/src/modules/theme/maps/ThemeTypeToThemeVariablesMap'
import {resolveThemeType} from '@toolify/server/src/services/UserSettingsService/strategies/ThemeUserSettingStrategy/functions/resolveThemeType'
import {EntityType} from '@toolify/server/src/services/EntityService/enum/EntityType'
import {IUserResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IUserResponseInstance'

export function getNotificationThemeVariable<T extends ThemeVariableType>(variableName: T): IThemeVariables[T] {
  const authStore = useAuthStore()
  const user = authStore.currentEntity?.entityType === EntityType.User
    ? authStore.currentEntity.payload as IUserResponseInstance
    : null
  const themeVariables = ThemeTypeToThemeVariablesMap.get(resolveThemeType(user?.settings?.theme))
  return themeVariables[variableName]
}
